export const COMPONENT_GAP_PX = '24px';
export const TOP_GAP_PX = '32px';
export const TOP_GAP_PX_DESKTOP = '64px';
export const BOTTOM_GAP_PX = '64px';
export const BOTTOM_GAP_PX_DESKTOP = '80px';
